
          <div class="outside-container ">
            <!-- <div class="box-container ">
                <div class="container "> -->
                  <div *ngIf="!showPnrRetrieval" class="col-md-12   " >

                    <div  class="col-md-3 mb-2 mt-2  flex justify-content-start">
                      <span *ngIf="this.tokenData.userType==='CORPORATE'||this.tokenData.userType==='AGENT'" class="form-control" >{{this.tokenData?.name}}, {{this.tokenData?.username}}</span>

                      <p-autoComplete *ngIf="this.tokenData.userType!='CORPORATE'&&this.tokenData.userType!='AGENT'"
                  styleClass="col-md-12"
                  [(ngModel)]="userName" 
                  [dropdown]="true" 
                  [suggestions]="filteredUser" 
                  (completeMethod)="searchList($event)" 
                  field="name">
                  <ng-template let-user pTemplate="item">
                   <div class="flex align-items-start " style="text-align: start;">
                       
                       <div>{{ user.name+' , '+ user.username }}</div>
                   </div>
                  </ng-template>
                  </p-autoComplete>
                  </div>


                    <form [formGroup]="pnrRegFg"  autocomplete="off"  class=" row">

                    <!-- <form   autocomplete="off"  class=" col-md-12 row"> -->
                        <mat-form-field class="col-md-4" appearance="outline">
                            <mat-label>Type</mat-label>
                            <mat-select matNativeControl name="airProduct"  >
                                <mat-option value="air">Air</mat-option>
                                <!-- <mat-option value="hotel">Hotel</mat-option>
                                <mat-option value="package">Package</mat-option> -->

                              </mat-select>

                          </mat-form-field>
                          <mat-form-field class="col-md-4" appearance="outline" >
                            <mat-label>Supplier</mat-label>
                            <mat-select matNativeControl name="supplier" (selectionChange)="onClickSupplier($event)" formControlName='supplier'>
                                <mat-option *ngFor="let supplier of supplierList " [value]="supplier.code">{{supplier.name}}</mat-option>
                              </mat-select>             

                            </mat-form-field>
                          <mat-form-field class="col-md-4" appearance="outline">
                            <mat-label>Source</mat-label>
                            <mat-select matNativeControl name="source"  formControlName='source'>
                                <mat-option *ngFor="let source of filterSourceList " [value]="source.name">{{source.sourceName}}</mat-option>
                            </mat-select>                   

                            </mat-form-field>
                          <mat-form-field class="col-md-4" appearance="outline">
                            <mat-label>PNR</mat-label>
                            <input matInput type="text" formControlName="pnrNumber">              
                            </mat-form-field>
                         
                         
                          <div  class=" col-md-8  d-flex justify-content-end" >
                            <button *ngIf="!disabled&&userName"   mat-flat-button  style="width: auto; height: 55px; color: white; background-color: #1e8f5a;; margin-right: 8px;font-weight: bold;"  (click)="AddCart()" [disabled]="pnrRegFg.invalid">Retrieve PNR </button>
                            <button *ngIf="disabled||!userName"   mat-flat-button  style="width: auto; height: 55px; color: white; background-color: #84b29d;; margin-right: 8px;font-weight: bold;"  [disabled]="pnrRegFg.invalid">Retrieve PNR </button>

                        </div>
                       
                        </form>

                  
                </div>
                <div *ngIf="showPnrRetrieval" class="col-md-12  d-flex justify-content-center " style="padding-left: 20px; ">
                  <app-generate-pnr (myOutput)="GetChildData()"></app-generate-pnr>
                  <div  *ngIf="false">
            <div  class="col-md-12" *ngFor="let item of pnrData">
                <div class="col-md-12" *ngFor="let segment of item.pnrItineraryDetails">
               <div  class="col-md-12 title mt-2" style="max-height: 50px;" >
                <div  ><span>{{cityFilter(segment?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(segment.toAirport)}}</span> <span *ngIf="segment.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(segment.schDepartureTime)}}</span></div>
</div>
                <form   autocomplete="off"  class=" mt-4 row">

                    <!-- <form   autocomplete="off"  class=" col-md-12 row"> -->
                        <mat-form-field class="col-md-4" appearance="outline">
                            <mat-label>Source</mat-label>
                            <input matInput type="text" readonly [(ngModel)]="pnrRegFg.value.source" [ngModelOptions]="{standalone: true}">              


                          </mat-form-field>
                          <mat-form-field class="col-md-4" appearance="outline" >
                            <mat-label>Carrier</mat-label>
                            <input matInput type="text" readonly  [(ngModel)]="segment.carrierName" [ngModelOptions]="{standalone: true}">              
        

                            </mat-form-field>
                          <mat-form-field class="col-md-4" appearance="outline">
                            <mat-label>Supplier</mat-label>
                            <input matInput type="text" readonly [(ngModel)]="pnrRegFg.value.supplier" [ngModelOptions]="{standalone: true}">              
                   

                            </mat-form-field>
                          <mat-form-field class="col-md-4" appearance="outline">
                            <mat-label>PF Code	</mat-label>
                            <input matInput type="text" >              
                            </mat-form-field>
                            
                         
                                <mat-form-field class="col-md-4" appearance="outline">
                                    <mat-label>Flight Number	</mat-label>
                                    <input matInput type="text" [(ngModel)]="segment.flightNumber" [ngModelOptions]="{standalone: true}">              
                                    </mat-form-field>
                                    <mat-form-field class="col-md-4" appearance="outline">
                                        <mat-label>ROE</mat-label>
                                        <input matInput type="text" >              
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                            <mat-label>Currency</mat-label>
                                            <input matInput type="text" >              
                                            </mat-form-field>
                                            
                        
                          <div  class=" col-md-12  d-flex justify-content-end" >
                            <!-- <button   mat-flat-button  style="width: auto; height: 55px; color: white; background-color: #1e8f5a;; margin-right: 8px;font-weight: bold;" (click)="AddCart()" [disabled]="pnrRegFg.invalid">Create Cart </button> -->

                        </div>
                       
                        </form>

            </div>
            <div class="col-md-12">

                <table class="styled-tables ">
                    <thead>
                      <tr >
                        <!-- Dynamic headers based on tableHeaders array -->
                        <th style="padding: 8px;  text-align: center;">Passenger 
                        </th>
                        <th style="padding: 8px;  text-align: center;">Class/Type	</th>
                        <th style="padding: 8px;  text-align: center;">Fare & Tax Breakup	</th>
                              <th style="padding: 8px;  text-align: center;"  >OPC & GST	</th>
                              <th style="padding: 8px;  text-align: center;"  >Extra	
                                <th style="padding: 8px;  text-align: center;">Additional</th>
                        <!-- <th *ngIf="!showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" (click)="seatWindow()">Seat Selection	</th>
                        <th *ngIf="showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">Seat Selection	<mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></th> -->



                      </tr>
                    </thead>
                    <tbody>
                      <!-- Iterate through dynamic data rows -->


                      <tr *ngFor="let con of item.passengerDetails; let i=index">
                        
                        <td class=""style="padding: 8px;  text-align: center;" >
                       {{con?.passengerTitle}}  {{con?.firstName}}  {{con?.lastName}} <br>
                       {{con.passengerType==="ADT"?("Adult"):con.passengerType==="CHD"?("Child"):con.passengerType==="INF"?("Infant"):''}} {{i+1}}
                        </td>
                        <td class=""style="padding: 8px;  text-align: center;" >
                        <span ></span>
                            <!-- <mat-form-field class="col-md-12" appearance="outline">
                                <mat-label>Booking Class	</mat-label>
                                <input matInput type="text" readonly [(ngModel)]="pnrRegFg.value.supplier" [ngModelOptions]="{standalone: true}">              
                       
    
                                </mat-form-field>
                                <mat-form-field class="col-md-12" appearance="outline">
                                    <mat-label>Cabin Class	</mat-label>
                                    <input matInput type="text" readonly [(ngModel)]="pnrRegFg.value.supplier" [ngModelOptions]="{standalone: true}">              
                           
        
                                    </mat-form-field>
                                    <mat-form-field class="col-md-12" appearance="outline">
                                        <mat-label>Fare Type</mat-label>
                                        <input matInput type="text" readonly [(ngModel)]="pnrRegFg.value.supplier" [ngModelOptions]="{standalone: true}">              
                               
            
                                        </mat-form-field> -->
                      </td>

                      <td class=""style="padding: 8px;  text-align: center;" >  
                    </td>
                    <td class=""style="padding: 8px;  text-align: center;" >
                    </td>
                    <td class=""style="padding: 8px;  text-align: center;" >
                    </td>
                    <td class=""style="padding: 8px;  text-align: center;" >
                    </td>

                      </tr>
                    </tbody>
                  </table>
                  <div class="col-md-12">

                    <table class="styled-tables ">
                        <thead>
                          <tr >
                            <!-- Dynamic headers based on tableHeaders array -->
                            <th style="padding: 8px;  text-align: center;">Airline PNR	 
                            </th>
                            <th style="padding: 8px;  text-align: center;">CRS PNR	</th>
                            <th style="padding: 8px;  text-align: center;">Ticket Number		</th>
                             
                           
    
    
                          </tr>
                        </thead>
                        <tbody>
                          <!-- Iterate through dynamic data rows -->
    
    
                          <tr >
                            
                            <td class=""style="padding: 8px;  text-align: center;" >
                          {{item.pnrNumber||""}}
                            </td>
                            <td class=""style="padding: 8px;  text-align: center;" >
                                {{item.crsPNR||""}}
                            </td>
    
                          <td class=""style="padding: 8px;  text-align: center;" >  
                            {{""}}
                        </td>
                       
    
                          </tr>
    
    
    
    
    
    
    
    
    
    
    
                     
                        </tbody>
                      </table>
</div>

<div class="col-md-12">

    <table class="styled-tables ">
        <thead>
          <tr >
            <!-- Dynamic headers based on tableHeaders array -->
            <th style="padding: 8px;  text-align: center;">Meal preference	 
            </th>
            <th style="padding: 8px;  text-align: center;">Seat Preference</th>
            <th style="padding: 8px;  text-align: center;">Seat Number			</th>
            <th style="padding: 8px;  text-align: center;">Baggage Preference				</th>

           


          </tr>
        </thead>
        <tbody>
          <!-- Iterate through dynamic data rows -->


          <tr *ngFor="let con of item.passengerDetails; let i=index">
            
            <td class=""style="padding: 8px;  text-align: center;" >
                {{con.seatMeal||""}}
            </td>
            <td class=""style="padding: 8px;  text-align: center;" >
                {{""}}
            </td>

          <td class=""style="padding: 8px;  text-align: center;" >  
            <span *ngFor="let itinerary of con.flightDetailsWithPassengerPreferences">
            {{itinerary.seat.row?(itinerary.seat.row+itinerary.seat.column):""}}</span>
        </td>
        <td class=""style="padding: 8px;  text-align: center;" >  
        {{""}}    
    </td>

          </tr>











     
        </tbody>
      </table>
</div>
        </div>

                </div>

               